import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Scrolls viewport to top whenever the location pathname changes (smoothly).
// Uses double requestAnimationFrame to let the new page/layout paint first
// which avoids jank when content height changes on navigation.
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

    const performScroll = () => {
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          // Respect reduced motion setting; fall back gracefully if smooth unsupported.
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      } catch {
        // Older browsers: fall back to instant
        window.scrollTo(0, 0);
      }
    };

    // Allow layout to settle: two rAFs = after next paint.
    requestAnimationFrame(() => requestAnimationFrame(performScroll));
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
